// @unocss-include
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { Toaster } from 'react-hot-toast';
import { useVisualViewportOffset } from '../../hooks.js';
import { useVirtualKeyboardBehavior } from '../../hooks/useVirtualKeyboardBehavior.js';
import { IconSpritesheet } from '../icon/index.js';
import { ParticleLayer } from '../particles/index.js';
import { TooltipProvider } from '../tooltip/index.js';
/**
 * Provides all the stuff for all global junk.
 */
export function Provider({ children, disableParticles, toastPosition = 'top-center', toastContainerClassName, disableViewportOffset, virtualKeyboardBehavior = 'displace', }) {
    useVisualViewportOffset(disableViewportOffset);
    const supportedVirtualKeyboardBehavior = typeof navigator !== 'undefined' && 'virtualKeyboard' in navigator
        ? virtualKeyboardBehavior
        : 'displace';
    useVirtualKeyboardBehavior(supportedVirtualKeyboardBehavior);
    const otherStuff = (_jsxs(_Fragment, { children: [_jsx(IconSpritesheet, {}), _jsx(Toaster, { position: toastPosition, containerClassName: toastContainerClassName })] }));
    if (disableParticles)
        return (_jsx(ConfigContext.Provider, { value: { virtualKeyboardBehavior: supportedVirtualKeyboardBehavior }, children: _jsxs(TooltipProvider, { children: [children, otherStuff] }) }));
    return (_jsx(ConfigContext.Provider, { value: { virtualKeyboardBehavior: supportedVirtualKeyboardBehavior }, children: _jsx(TooltipProvider, { children: _jsxs(ParticleLayer, { children: [children, otherStuff] }) }) }));
}
export const ConfigContext = createContext({
    virtualKeyboardBehavior: 'displace',
});
export function useConfig() {
    return useContext(ConfigContext);
}
//# sourceMappingURL=Provider.js.map